import SingleBannerBase from './SingleBannerBase';
export const SingleBanner = {
  SingleBanner_1_1: ({ item }) => {
    return <SingleBannerBase item={item} aspectRatio={1 / 1}></SingleBannerBase>;
  },
  SingleBanner_1_7_1_paddingless: ({ item }) => {
    return <SingleBannerBase item={item} aspectRatio={17 / 10}></SingleBannerBase>;
  },
  SingleBanner_2_7_1: ({ item }) => {
    return <SingleBannerBase item={item} aspectRatio={27 / 10}></SingleBannerBase>;
  },
  SingleBanner_1_7_1_rounded: ({ item }) => {
    return <SingleBannerBase item={item} aspectRatio={17 / 10}></SingleBannerBase>;
  },
  SingleBanner_1_6_2: ({ item }) => {
    return <SingleBannerBase item={item} aspectRatio={16 / 20}></SingleBannerBase>;
  },
  SingleBanner_1_5_1: ({ item }) => {
    return <SingleBannerBase item={item} aspectRatio={15 / 10}></SingleBannerBase>;
  },
  SingleBanner_full: ({ item }) => {
    return <SingleBannerBase item={item} aspectRatio={1 / 2.3}></SingleBannerBase>;
  },
  SingleBanner_dynamic: ({ item }) => {
    return <SingleBannerBase item={item} ></SingleBannerBase>;
  },
};
